// services/ExamSessionService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getExamSessions(params = {}) {
    return api.get(ENDPOINTS.EXAM_SESSIONS.BASE, { params });
}
export function getExamSessionById(id) {
    return api.get(ENDPOINTS.EXAM_SESSIONS.BY_ID(id));
}
export function createExamSession(payload) {
    return api.post(ENDPOINTS.EXAM_SESSIONS.BASE, payload);
}
export function updateExamSession(id, payload) {
    return api.patch(ENDPOINTS.EXAM_SESSIONS.BY_ID(id), payload);
}
export function deleteExamSession(id) {
    return api.delete(ENDPOINTS.EXAM_SESSIONS.BY_ID(id));
}
export function restoreExamSession(id) {
    return api.post(`${ENDPOINTS.EXAM_SESSIONS.BY_ID(id)}/restore`);
}
export function closeExamSession(id) {
    return api.post(ENDPOINTS.EXAM_SESSIONS.CLOSE(id));
}
export function openExamSession(id) {
    return api.post(ENDPOINTS.EXAM_SESSIONS.OPEN(id));
}
export function cancelExamSession(id) {
    return api.post(ENDPOINTS.EXAM_SESSIONS.CANCEL(id));
}

// Salles affectées à une session ("nombre de salles et de surveillants")
export function getSessionRooms(id) {
    return api.get(ENDPOINTS.EXAM_SESSIONS.ROOMS(id));
}
export function assignRoomToSession(id, room_id, proctor_user_id) {
    return api.post(ENDPOINTS.EXAM_SESSIONS.ROOMS(id), { room_id, proctor_user_id: proctor_user_id || null });
}
export function unassignRoomFromSession(id, roomId) {
    return api.delete(ENDPOINTS.EXAM_SESSIONS.UNASSIGN_ROOM(id, roomId));
}

// Liste d'émargement (Excel)
export async function downloadAttendanceSheet(id) {
    return api.get(
        ENDPOINTS.EXAM_SESSIONS.ATTENDANCE_SHEET(id)
    );
}
